export default __webpack_public_path__ + "static/media/email.7132eb5e.svg";